<nav class="nav" [ngClass]="{'horizontal':layout() === 'horizontal', 'vertical':layout() === 'vertical'}"
     role="navigation" 
     [attr.aria-label]="layout() === 'horizontal' ? 'Menu principal horizontal' : 'Menu principal vertical'">

  <!-- Vertical Navigation Layout -->
  @if (layout() === 'vertical') {
    <ul role="menubar" aria-orientation="vertical" class="nav-list">
      @for (item of navigation; track item) {
        @if (item.type==='group') {
          <cdk-nav-vertical-group [item]="item"></cdk-nav-vertical-group>
        }
        @if (item.type==='collapsable') {
          <cdk-nav-vertical-collapsable
          [item]="item"></cdk-nav-vertical-collapsable>
        }
        @if (item.type==='item') {
          <cdk-nav-vertical-item [item]="item"></cdk-nav-vertical-item>
        }
      }
    </ul>
  }
  <!-- / Vertical Navigation Layout -->

  <!-- Horizontal Navigation Layout -->
  @if (layout() === 'horizontal') {
    <ul role="menubar" aria-orientation="horizontal" class="nav-list">
      @for (item of navigation; track item) {
        @if (item.type==='group') {
          <cdk-nav-horizontal-collapsable [item]="item"></cdk-nav-horizontal-collapsable>
        }
        @if (item.type==='collapsable') {
          <cdk-nav-horizontal-collapsable
          [item]="item"></cdk-nav-horizontal-collapsable>
        }
        @if (item.type==='item') {
          <cdk-nav-horizontal-item [item]="item"></cdk-nav-horizontal-item>
        }
      }
    </ul>
  }
  <!-- / Horizontal Navigation Layout -->

</nav>
